import { render, staticRenderFns } from "./zfpage.vue?vue&type=template&id=b368ecc4&scoped=true&lang=pug"
import script from "./zfpage.vue?vue&type=script&lang=js"
export * from "./zfpage.vue?vue&type=script&lang=js"
import style0 from "./zfpage.vue?vue&type=style&index=0&id=b368ecc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b368ecc4",
  null
  
)

export default component.exports